import TRANSLATIONS from './json/de_AT_translations.json'

const TRANSLATIONS_DE_AT = {
  'checkout_shipping.pOBoxWarningText': `${window.appConfig?.pOBoxWarningText}`,
  'shopping_cart_details.hoverToZoom': 'Zum Zoomen darauf zeigen',
  'shopping_cart_details.tapToZoom': 'Zum Zoomen tippen',
  'coupon_code.page_link': 'national-pen-gutscheine',
  'order_summary.your_promos' : 'Ihre Rabatt-Codes',
  'shopping_cart_details.editImprint': 'Aufdruck bearbeiten',
  'shopping_cart_details.clickToZoom': 'Zum Zoomen klicken',
  'shopping_cart_details.ships_within_msg': 'Versand innerhalb von [X] Werktagen',
  'shopping_cart_details.item_total': 'Gesamtpreis:',
  'shopping_cart_details.each': 'Je [X]',
  'shopping_cart_details.see_more': 'Mehr Anzeigen',
  'shopping_cart_details.see_less': 'Weniger Anzeigen',
  'order_confirmation.cartToOrderFailureMessage' : 'Sie erhalten in Kürze eine Bestellbestätigung.',
  'checkout_payment.paymentErrorTitle': 'Fehler bei der Zahlung',
  'checkout_payment.paymentErrorMessage': 'Bitte versuchen Sie, Ihre Zahlungsdaten erneut einzugeben. Sollte das Problem weiterhin bestehen, wenden Sie sich bitte an unseren Kundendienst.',
  'checkout_payment.empty_string': '',
  'checkout_payment.credit_debit': 'Kredit-/Debitkarte',
  'checkout_payment.card_number': 'Kreditkartennummer*',
  'checkout_payment.expiration_mm_yy': 'MM/JJ*',
  'checkout_payment.cvv': 'CVV*',
  'checkout_payment.name_on_card': 'Name auf der Karte*',
  'checkout_payment.check_cc_try_again': 'Bitte überprüfen Sie die Kreditkartennummer und versuchen Sie es erneut.',
  'checkout_payment.check_date_try_again': 'Bitte überprüfen Sie das Datum und versuchen Sie es erneut.',
  'checkout_payment.check_code_try_again': 'Bitte überprüfen Sie den Code und versuchen Sie es erneut.',
  'checkout_payment.enter_holder_name': 'Bitte überprüfen Sie den Namen auf Ihrer Kreditkarte.',
  'checkout_payment.enter_cc_number': 'Geben Sie die Kreditkartennummer ein.',
  'checkout_payment.enter_expiration_date': 'Geben Sie das Ablaufdatum ein.',
  'checkout_payment.enter_cvv': 'Geben Sie den Sicherheitscode ein.',
  'checkout_payment.paypal_pay_later': 'PayPal Später bezahlen',
  'checkout_payment.continue_will_open_paypal_account_msg': 'Sie werden zu Ihrem PayPal-Konto weitergeleitet, wenn Sie diese Schaltfläche anklicken.',
  'checkout_payment.continue_will_open_google_pay_account_msg': 'Durch Fortsetzen kommen Sie zu Google Pay.',
  'checkout_payment.paypal': 'PayPal',
  'checkout_payment.pay_by_invoice': 'Auf Rechnung bestellen',
  'checkout_payment.buy_now_pay_later_info_msg': 'Jetzt kaufen, später bezahlen! Sofort nach dem Versand Ihrer Bestellung erhalten Sie Ihre Rechnung - vollständig und ordnungsgemäß - direkt in Ihr E-Mail-Postfach.',
  'checkout_payment.learn_more': 'Mehr erfahren',
  'checkout_payment.payment_due_late_fee_info_msg': 'Die Zahlung ist nach Erhalt der Rechnung fällig. Bei Zahlungsverzug fallen womöglich Gebühren an.',
  'shopping_cart_details.unit': 'Stück',
  'shopping_cart_details.editModalSaving': `Sie sparen`,
  'shopping_cart_details.editModalMin_QtyWarning': `Das tut uns leid, das unterschreitet leider unsere Mindestbestellmenge. Um eine kleinere Bestellung aufzugeben, kontaktieren Sie uns bitte unter 0800-724-04-05.`,
  'shopping_cart_details.editModalMax_QtyWarning': `Das tut uns leid, das überschreitet leider unsere maximale Menge. Um eine größere Bestellung aufzugeben, kontaktieren Sie uns bitte unter 0800-724-04-05.`,
  'product_details.price':'Preis',
  'product_details.edit_quantity':'Menge bearbeiten',
  'myaccount_order_details.seeDetails': 'Mehr dazu',
  'myaccount_order_details.viewOrderDetails': 'Bestellinformationen anzeigen',
  'myaccount_order_details.payMyInvoice': 'Rechnung bezahlen',
  'myaccount_order_details.buyItAgain': 'Erneut kaufen',
  'myaccount_order_details.viewImprint': 'Aufdruck ansehen',
  'myaccount_order_details.viewArtwork': 'Design anzeigen',
  'myaccount_order_details.productDetails': 'Produktdetails',
  'myaccount_order_details.orders': 'Bestellungen',
  'my_account_order_details.shipping_and_billing_addresses': 'Liefer- und Rechnungsadressen',
  'my_account_order_details.log_in_to_view' : 'Zur Ansicht bitte einloggen',
  'error.use_of_old_password': 'Muss anders als die letzten fünf Passwörter sein.',
  'order_confirmation.postCheckout_signIn':`Einloggen und mehr profitieren`,
  'order_confirmation.postCheckout_accountCreation':'Anmelden und mehr profitieren',
  'order_confirmation.postCheckout_trackOrder':'Bestellverfolgung einfach gemacht',
  'order_confirmation.would_you_like_to':'Erhalten Sie besondere Rabatte und Gratismuster, wenn Sie sich für E-Mail- und Telefonangebote von Pens.com anmelden.',
  'order_confirmation.sign_up.contact_agreement1':'Ja',
  'order_confirmation.sign_up.contact_agreement2':', ich liebe Schnäppchen.',
  'order_confirmation.sign_up.contact_disagreement1':'Nein',
  'order_confirmation.sign_up.contact_disagreement2':', danke.',
  'create_account.title':'Konto erstellen',
  'order_confirmation.sign_in.title':'Mit Konto anmelden',
  'order_confirmation.my_acc.title':'Mein Konto',
  'order_confirmation.addPassword':'Sie müssen nur ein Passwort eingeben:',
  'order_confirmation.accountCreated':'Konto erstellt',
  'myaccount_address_list.shippingAddresses': 'Lieferadressen',
  'myaccount_address_list.billingAddresses': 'Rechnungsadressen',
  'myaccount_address_list.defaultAddress': 'Standardadresse',
  'myaccount_address_list.setDefault': 'Voreingestellt',
  'myaccount_delete_address.delete_confirmation': 'Bestätigung',
  'myaccount_delete_address.confirmation_message': 'Sind Sie sicher, dass Sie diese Adresse entfernen möchten?',
  'myaccount_delete_address.delete_address': 'Adresse entfernen',
  'myaccount_delete_address.delete': 'Entfernen',
  'myaccount_error_new_password.complexity':"Das neue Passwort muss eine Zahl, ein Sonderzeichen [!#$%&'*+-/=?^_`{|}~.@] und einen Groß- und Kleinbuchstaben enthalten.",
  'myaccount_error_confirm_password.complexity':"Das bestätigte Passwort muss eine Zahl, ein Sonderzeichen [!#$%&'*+-/=?^_`{|}~.@] und einen Groß- und Kleinbuchstaben enthalten.",
  'myaccount_error_new_password.common_password':'Das neue Passwort darf nicht Ihre E-Mail-Adresse sein.',
  'myaccount_error_confirm_password.common_password':'Das bestätigte Passwort darf nicht Ihre E-Mail-Adresse sein.',
  'myaccount.change_personal_information.change_password_info' : 'Sie werden von allen aktiven Geräten abgemeldet.',
  'validation.password_validation_heading' : 'Das Passwort muss enthalten:',
  'validation.password_validation_uppercase' : 'einen Großbuchstaben',
  'validation.password_validation_lowercase' : 'einen Kleinbuchstaben',
  'validation.password_validation_symbol' : 'ein Sonderzeichen',
  'validation.password_validation_number' : 'eine Zahl',
  'validation.password_validation_length' : 'Mindestens 8 Zeichen',
  'validation.password_validation_match' : 'Passwörter müssen übereinstimmen',
  'validation.password_min_characters': 'Das Passwort muss mindestens 8 Zeichen lang sein.',
  'myaccount_password_settings.heading' : 'Passworteinstellungen',
  'myaccount_password_settings.newPassword' : 'Neues Passwort',
  'myaccount_password_settings.confirmPassword' : 'Passwort bestätigen',
  'myaccount_password_settings.updatePassword' : 'Passwort aktualisieren',
  'myaccount_password_settings.createPassword' : 'Passwort erstellen',
  'myaccount_password_settings.use_of_old_password': 'Das Passwort darf nicht eines Ihrer letzten 5 Passwörter sein.',
  'order_details.payment_mode_apple_pay' : 'Apple Pay',
  'order_details.payment_mode_google_pay' : 'Google Pay',
  'order_details.payment_mode_ideal' : 'iDEAL',
  'order_details.payment_mode_bancontact' : 'Bancontact',
  'order_details.payment_mode_klarna' : 'Klarna',
  'shopping_bag.expired_discount_coupon':'Der eingegebene Angebotscode ist nicht mehr gültig. Bitte geben Sie einen anderen Angebotscode ein.',
  'shopping_bag.invalid_discount_coupon':'Der eingegebene Angebotscode ist nicht gültig. Bitte geben Sie einen anderen Angebotscode ein.',
  'order_summary.oops_error': 'Oje, es ist leider ein Fehler aufgetreten. Bitte versuchen Sie es noch einmal.',
  'order_summary.one_promo_at_a_time': 'Es kann immer nur ein Angebotscode angewendet werden.',
  'order_summary.code_applied': 'Code angewendet',
  'order_summary.change_promo': 'Angebotscode ändern',
  'order_summary.your_promo_code': 'Ihre Angebotscodes',
  'order_summary.no_items_eligible': 'Der Angebotscode kann auf keinen der Artikel im Warenkorb angewendet werden.',
  'order_details.production_time_begin_msg': '*Die Produktionszeit beginnt, sobald die Bestellung bestätigt und die Druckvorlagen genehmigt sind.',
  'order_details.reorder_tat': 'Nachbestellungen werden in X Werktagen versandt*',
  'dashboard.edit' : 'Bearbeiten',
  'dashboard.greeting':'Hallo,',
  'myaccount_personal_info.save_changes' : 'Änderungen speichern',
  'myaccount_personal_info.cancel' : 'Abbrechen',
  'myaccount_personal_info.name_title' : 'Name',
  'myaccount_personal_info.password_title' : 'Passwort',
  'myaccount_personal_info.add_name' : 'Name hinzufügen',
  'myaccount_personal_info.edit_name' : 'Name bearbeiten',
  'myaccount_personal_info.name_updated' : 'Name wurde aktualisiert',
  'myaccount.something_went_wrong': 'Leider ist ein Fehler aufgetreten. Bitte versuchen Sie es noch einmal.',
  'checkout.reorder.buy_it_again':'Erneut kaufen',
  'checkout.reorder.purchased':'Gekauft',
  'checkout.reorder.last_qty':'Zuletzt bestellte Menge',
  'checkout.reorder.ships_within_msg':'Versand innerhalb von [X] Werktagen',
  'checkout.reorder.add_to_cart': 'Zum Warenkorb hinzufügen',
  'shopping_cart_details.add_accessory': 'Zubehör hinzufügen',
  'oos.item_out_of_stock': 'Dieser Artikel ist derzeit nicht vorrätig.',
  'oos.view_similar': 'Ähnliche Produkte ansehen',
  'oos.similar_products': 'Ähnliche Produkte',
  'oos.remove_out_of_stock_items': 'Bitte entfernen Sie nicht vorrätige Artikel aus Ihrem Warenkorb.',
  'oos.one_or_more_items_removed_from_cart': 'Eine oder mehrere Größen sind nicht vorrätig und die jeweiligen Artikel wurden aus dem Warenkorb entfernt.',
  'oos.go_back_to_review': 'Warenkorb überprüfen',
  'oos.go_back_to_remove': 'Artikel aus Warenkorb entfernen',
  'oos.out_of_stock': 'Nicht auf Lager',
  'shopping_cart_details.add_amount': 'Fügen Sie noch [X] hinzu, um das Angebot nutzen zu können',
  'import_charge_title':'Einfuhrabgabe',
  'import_charge_description':'Die jüngsten Entwicklungen bei den Einfuhrabgaben haben sich auf die Preise unserer Produkte ausgewirkt. Im Interesse unserer Kundschaft setzen wir alles daran, Preiserhöhungen so gering wie möglich zu halten.',
  'gdpr.heading' : 'Konto erstellt. Willkommen!',
  'gdpr.subheading' : 'Sie haben mit der folgenden E-Mail-Adresse ein Konto erstellt:',
  'gdpr.promotion': 'Melden Sie sich für die E-Mails von Pens.com an und freuen Sie sich über besondere Angebote und kostenlose Muster.',
  'gdpr.yesDeal' : 'Ja, ich will kein Angebot verpassen',
  'gdpr.noDeal' : 'Nein, danke',
  'gdpr.button' : 'Weiter',
  'new_activation.head' : 'Überprüfen Sie Ihr Postfach!',
  'new_activation.sub_head' : 'Hallo,',
  'new_activation.main_body1' : 'es freut uns, Sie bei Pens.com begrüßen zu dürfen.',
  'new_activation.main_body2' : 'Ein Aktivierungslink wird an Ihre eingetragene E-Mail-Adresse gesendet',
  'new_activation.main_body3' : 'Sie können sich nicht anmelden, bis Ihr Konto aktiviert worden ist. Bitte klicken Sie auf den Aktivierungslink, um Ihr Konto zu aktiveren.',
  'myaccount_personal_info.password_not_set' : 'Für dieses Konto wurde noch kein Passwort festgelegt. Klicken Sie bitte',
  'myaccount_personal_info.click_here' : 'hier,',
  'myaccount_personal_info.to_reset_password' : 'um ein neues Passwort einzugeben.',
  'myaccount_personal_info.note' : 'Hinweis: Dadurch werden alle aktiven Sitzungen beendet.',
  'moq.lineItem_warning': 'Die Bestellmenge liegt unter der Mindestbestellmenge dieses Artikels.',
  'moq.edit_qantity_link_text': 'Bitte wählen Sie eine neue Menge aus.',
  'moq.cart_level_warning': 'Bitte aktualisieren Sie die Bestellmenge, um fortzufahren.',
  'moq.go_back_to_cart': 'Zurück zum Warenkorb, um die neue Bestellmenge auszuwählen',
  ...TRANSLATIONS
};
export default TRANSLATIONS_DE_AT;